module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__select-system--container"
  }, [_c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.remote_start_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.remote_start_image.url,
      "alt": _vm.sharedState.customFields.remote_start_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.remote_start_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.remote_start_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('START IT')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.security_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.security_image.url,
      "alt": _vm.sharedState.customFields.security_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.security_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.security_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('ALARM IT')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-system--item"
  }, [(_vm.sharedState.customFields.remote_start_security_image) ? _c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.remote_start_security_image.url,
      "alt": _vm.sharedState.customFields.remote_start_security_image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.remote_start_security_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.remote_start_security_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.saveSelectedSystem('MAX IT')
      }
    }
  }, [_vm._v("Select")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08502506","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/SelectSystem.vue
// module id = 413
// module chunks = 1